import { createRouter, createWebHashHistory } from "vue-router";
import Layout from "@/components/Layout/LayoutMain.vue";

export const navPages = [
  {
    path: "/home",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "HomeMain" */ "../views/Home/HomeMain.vue"),
    meta: {
      title: "首页",
    },
  },
];

const routes = [
  {
    path: "/",
    redirect: "/home", // 访问 / 时，重定向到 /home
    component: Layout,
    meta: {
      title: "首页",
    },
    children: [...navPages],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 路由变化后：更新 body class
router.afterEach((to, from) => {
  // 清除旧的 class（可选）
  document.body.classList.remove(`body-${from.name}`);

  // 添加新的 class
  if (to.name) {
    document.body.classList.add(`body-${to.name}`);
  }
});

export default router;
